import React from "react";

const BS5_Badges = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Badges Component</h2>
      <p>This is the BS5_Badges component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Badges;
